import { render, staticRenderFns } from "./role-to-grant-authorization.vue?vue&type=template&id=0187b0e3&"
import script from "./role-to-grant-authorization.vue?vue&type=script&lang=js&"
export * from "./role-to-grant-authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports